import { createFileRoute } from '@tanstack/react-router';
import { ExtensionsPage } from '../../features/settings/components/extensions-page.js';

export const Route = createFileRoute('/admin/extensions')({ component: ExtensionsPage });
